/* eslint-disable @typescript-eslint/no-explicit-any */
import { FormControl, FormGroup } from '@angular/forms';
import { LocalDate, LocalDateTime } from './date.model';

export type ControlsOf<T extends Record<string, any>> = {
  [K in keyof T]-?: T[K] extends Date | LocalDate | LocalDateTime | Array<any>
    ? FormControl<T[K]>
    : T[K] extends Record<any, any>
      ? FormGroup<ControlsOf<T[K]>>
      : FormControl<T[K]>;
};
